import { Card, Stack, Tab, Tabs, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import CustomTabPanel from './TabPanel';
import LoadingContent from 'components/LoadingContent';
import { useParams } from 'react-router-dom';
import { checkEnableParseJSON } from 'components/helper/helper';
import activitiesAndHonorsServices from 'services/activitiesAndHonorsServices';
import ActivitySum from 'screen/summary/components/ActivitySum';
import HonorSum from 'screen/summary/components/HonorSum';
import EducationalProgramrSum from 'screen/summary/components/EducationalProgramrSum';
import ItemContent from 'screen/summary/components/ItemContent';
import { useAppSelector } from 'app/hooks';
import { buildPageStatusClassName } from './RPersonalInformation';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import { ExpandMore } from 'screen/activitiesAndHonors/Activities';
import { PAGE_NAME, USER_ROLE } from 'constants/common';
import { usePageStatus } from 'hooks/usePageStatus';
import websocketService from 'services/websocketService';
import pageStatusService from 'services/pageStatusService';
import { getAccessToken, getUserRole } from 'utils/sessionStorage';

const RActivitiesAndHonors = ({
  setCurrentModuleId,
  isCounselor,
}: {
  setCurrentModuleId: (id: string) => void;
  isCounselor?: boolean;
}) => {
  const [value, setValue] = React.useState(1);
  const params: { id?: string | number } = useParams();
  const { pageStatus } = usePageStatus({ studentId: params.id || '' });
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);


  useEffect(() => {
    setIsMobile(window.innerWidth <= 768);
  }, [window.innerWidth]);

    
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setCurrentModuleId(`6.${newValue}`);
  };
  const checkModule = useAppSelector((store:any) => store.basicInformation.checkModule);
  return (
    <div>
      <Tabs
        className='mt-2'
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          position: 'sticky',
          top: isCounselor ? '72px' : '0',
          left: 0,
          right: 0,
          zIndex: 11,
          backgroundColor: '#fff',
          borderBottom: '1px solid',
          borderColor: 'divider',
          paddingTop: '8px',
          paddingBottom: '8px',
          marginTop: 0,
          width: '100%',
          willChange: 'transform',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden',
        }}
      >
        <Tab value={1} label="Activities 1-10" 
        // className={buildClassName('6.1', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.ACTIVITIES)} />
        <Tab value={5} label="Activities 11-20" 
        // className={buildClassName('6.5', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.ACTIVITIES)} />
        <Tab value={6} label="Activities 20+" 
        // className={buildClassName('6.6', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.ACTIVITIES)} />
        <Tab value={2} label="Honors & Awards" 
        // className={buildClassName('6.2', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.HONORS)} />
        <Tab value={3} label="EOP and Other Info" 
        // className={buildClassName('6.3', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.EDUCATIONAL_PROGRAMS)} />
        <Tab
          value={4}
          label="Responsibilities and Circumstances"
          // className={buildClassName('6.4', checkModule)} 
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.RESPONSIBILITIES_AND_CIRCUMSTANCES)}
        />
      </Tabs>
      <CustomTabPanel value={value} index={1}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryActivities startIndex={0} isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryActivities startIndex={10} isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={6}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryActivities startIndex={20} isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryHonors isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryOther isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryResponsibilitiesAndCircumstances isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
    </div>
  );
};

export default RActivitiesAndHonors;

const SummaryActivities = ({ startIndex, isMobile }: { startIndex: number, isMobile: boolean }) => {
  const [data, setData] = React.useState<any>({
    myActivities: null,
    is_have_any_activity_to_report: null,
  });
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => { 
    const newValue = !reviewedAndComplete;
    setReviewedAndComplete(newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.ACTIVITIES, newValue);
  }
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [expandAll, setExpandAll] = React.useState(false);
  const [expandActive, setExpandActive] = React.useState<number>(0);
  const [show, setShow] = React.useState(false);

  const handleClose = () => setShow(false);

  const dataActivity = (data?.myActivities ?? []).filter(
    (item: any, index: number) => index >= startIndex && index < startIndex + 10
  );

  const handleExpandAll = () => {
    setExpandAll(!expandAll);
    if (!expandAll) {
      setExpandActive(dataActivity.length);
    } else {
      setExpandActive(0);
    }
  };

  const handleExpandActive = (value: any) => {
    value
      ? setExpandActive(Math.abs(expandActive - 1))
      : setExpandActive(Math.abs(expandActive + 1));
  };

  React.useEffect(() => {
    if (expandActive === dataActivity.length) {
      setExpandAll(true);
    }

    if (expandActive === 0) {
      setExpandAll(false);
    }
  }, [expandActive, dataActivity.length, expandAll]);

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await activitiesAndHonorsServices.getActivitiesAndHonors(params.id);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.ACTIVITIES
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setData({
        myActivities: checkEnableParseJSON(res?.activity_array, []),
        is_have_any_activity_to_report: res?.is_have_any_activity_to_report,
      });
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          Activities
        </Typography>
        {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
          <Button
            className="btn btn-primary"
            onClick={() => setShow(true)}
            style={{ fontSize: '1rem' }}
          >
            Check Missing values
          </Button>
        )} */}
      </div>
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Introduction</div>
        <div className="gm-summary-field-label" style={{ fontSize: '1rem', marginBottom: 8 }}>
          Reporting activities can help colleges better understand your life outside of the classroom. Examples of activities might include: Arts or music, Clubs, Community engagement, Family responsibilities, Hobbies Sports, Work or volunteering, Other experiences that have been meaningful to you.
        </div>
      </div>
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">App Notes</div>
        <div className="gm-summary-field-label" style={{ fontSize: '1rem' }}>
          <div>Common Application allows for up to 10 Activities + 5 Honors or Awards</div>
          <div>UC Application allows for a total of 20 Activites, Honors or Awards</div>
        </div>
      </div>
      <div className="gm-summary-section">
          <ItemContent
            mdCol={12}
            label="Do you have any activities that you wish to report?"
            values={data?.is_have_any_activity_to_report}
          />
          
          {dataActivity && dataActivity?.length > 0 && (
            <>
              <div className="d-flex justify-content-end my-2">
                <ExpandMore aria-expanded={expandAll} aria-label="show all" onClick={handleExpandAll}>
                  {!expandAll ? <KeyboardDoubleArrowDownIcon /> : <KeyboardDoubleArrowUpIcon />}
                </ExpandMore>
              </div>

              <ActivitySum
                data={dataActivity}
                startIndex={startIndex}
                total={data?.myActivities?.length}
                expandAll={expandAll}
                handleExpandActive={handleExpandActive}
                showModal={show}
                closeModal={handleClose}
                dataCheck={{
                  ...data,
                  myActivities: dataActivity,
                }}
              />
            </>
          )}
      </div>
      {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
        <ModalCheckActivitiesFields show={show} onClose={handleClose} data={{ ...data, myActivities: dataActivity }} page="activities" />
      )} */}

      {getUserRole() === USER_ROLE.counselor && (
        <div className="gm-summary-checkbox-container">
          <div className="d-flex align-items-center" style={{ gap: '6px' }}>
            <input type="checkbox" style={{ width: '16px', height: '16px', border: '2px solid #6c757d', borderRadius: '2px' }} checked={reviewedAndComplete} onClick={onReviewdAndComplete} />
            <span style={{ fontSize: isMobile ? '14px' : '12px', color: '#6c757d', fontWeight: '500' }}>Reviewed & Complete!</span>
          </div>
        </div>
      )}
    </div>
  );
};

const SummaryHonors = ({ isMobile }: { isMobile: boolean }) => {
  const [data, setData] = React.useState<any>({
    myActivities: null,
    is_have_any_activity_to_report: null,
  });
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => { 
    const newValue = !reviewedAndComplete;
    setReviewedAndComplete(newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.HONORS, newValue);
  }
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();

  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await activitiesAndHonorsServices.getActivitiesAndHonors(params.id);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.HONORS
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setData({
        myHonors: checkEnableParseJSON(res?.honor_array, []),
        is_have_any_activity_to_report: res?.myActivityAndHonor?.is_have_any_activity_to_report,
      });
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          Honors & Awards
        </Typography>
        {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
          <Button
            className="btn btn-primary"
            onClick={() => setShow(true)}
            style={{ fontSize: '1rem' }}
          >
            Check Missing values
          </Button>
        )} */}
      </div>
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Introduction</div>
        <div className="gm-summary-field-label" style={{ fontSize: '1rem', marginBottom: 8 }}>
          If you have received any honors or awards related beginning with the ninth grade or international equivalent, please indicate them here.
        </div>
      </div>
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">App Notes</div>
        <div className="gm-summary-field-label" style={{ fontSize: '1rem' }}>
          <div>Common App - Allows you to report any honors related to your academic achievements beginning with the ninth grade or international equivalent. If you received more than five, please add the five most important to you.*</div>
          <div>UC App - Allow you to report up to 20 activities and honors combined.</div>
        </div>
      </div>
      <div className="gm-summary-section">
        {data.myHonors && <HonorSum data={data.myHonors} />}
      </div>
        {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
          <ModalCheckActivitiesFields show={show} onClose={handleClose} data={data} page="honors" />
        )} */}
        {getUserRole() === USER_ROLE.counselor && (
          <div className="gm-summary-checkbox-container">
            <div className="d-flex align-items-center" style={{ gap: '6px' }}>
              <input type="checkbox" style={{ width: '16px', height: '16px', border: '2px solid #6c757d', borderRadius: '2px' }} checked={reviewedAndComplete} onClick={onReviewdAndComplete} />
              <span style={{ fontSize: isMobile ? '14px' : '12px', color: '#6c757d', fontWeight: '500' }}>Reviewed & Complete!</span>
            </div>
          </div>
        )}
    </div>
  );
};

const SummaryOther = ({ isMobile }: { isMobile: boolean }) => {
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => { 
    const newValue = !reviewedAndComplete;
    setReviewedAndComplete(newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.EDUCATIONAL_PROGRAMS, newValue);
  }
  const [myEducationalProgram, setMyEducationalProgram] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();

  const [show, setShow] = React.useState(false);

  const handleClose = () => setShow(false);

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await activitiesAndHonorsServices.getEducationalProgram(params.id);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.EDUCATIONAL_PROGRAMS
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setMyEducationalProgram(res.csu_info);
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          EOP and Other Info
        </Typography>
        {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
          <Button
            onClick={() => setShow(true)}
            className="btn btn-primary"
            style={{ fontSize: '1rem' }}
          >
            Check Missing values
          </Button>
        )} */}
      </div>
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Introduction</div>
        <div className="gm-summary-field-label" style={{ fontSize: '1rem', marginBottom: 8 }}>
          Please review and complete the following EOP and other educational program information if applicable.
        </div>
      </div>
      <div className="gm-summary-section">
        {myEducationalProgram && (
          <EducationalProgramrSum data={checkEnableParseJSON(myEducationalProgram, [])} />
        )}
      </div>
      {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
        <ModalCheckActivitiesFields
          show={show}
          onClose={handleClose}
          data={checkEnableParseJSON(myEducationalProgram, [])}
          page="EOP"
        />
      )} */}
      {getUserRole() === USER_ROLE.counselor && (
        <div className="gm-summary-checkbox-container">
          <div className="d-flex align-items-center" style={{ gap: '6px' }}>
            <input type="checkbox" style={{ width: '16px', height: '16px', border: '2px solid #6c757d', borderRadius: '2px' }} checked={reviewedAndComplete} onClick={onReviewdAndComplete} />
            <span style={{ fontSize: isMobile ? '14px' : '12px', color: '#6c757d', fontWeight: '500' }}>Reviewed & Complete!</span>
          </div>
        </div>
      )}
    </div>
  );
};

const SummaryResponsibilitiesAndCircumstances = ({ isMobile }: { isMobile: boolean }) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState<any>(null);
  const params: { id?: string | number } = useParams();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => { 
    const newValue = !reviewedAndComplete;
    setReviewedAndComplete(newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.RESPONSIBILITIES_AND_CIRCUMSTANCES, newValue);
  }
  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await activitiesAndHonorsServices.getActivitiesAndHonors(params.id);
      setData(checkEnableParseJSON(res?.responsibilities_and_circumstances));
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.RESPONSIBILITIES_AND_CIRCUMSTANCES
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          Responsibilities and Circumstances
        </Typography>
          {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
            <Button
              className="btn btn-primary"
              onClick={() => setShow(true)}
              style={{ fontSize: '1rem' }}
            >
              Check Missing values
            </Button>
          )} */}
      </div>
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Introduction</div>
        <div className="gm-summary-field-label" style={{ fontSize: '1rem', marginBottom: 8 }}>
          Please review and complete the following information about your family responsibilities and personal circumstances if applicable.
        </div>
      </div>
      {data && (
        <>
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Responsibilities</div>
            <div>
              {(() => {
                const fields = [
                  { key: 'assistingFamily', label: "Assisting family or household members with tasks such as doctors' appointments, bank visits, or visa interviews" },
                  { key: 'farmWork', label: 'Farm work or unpaid work for a family business' },
                  { key: 'interpreting', label: 'Interpreting or translating for family or household members' },
                  { key: 'managingFinances', label: 'Managing family or household finances, budget, or paying bills' },
                  { key: 'providingTransportation', label: 'Providing transportation for family or household members' },
                  { key: 'takingCareOfSick', label: 'Taking care of sick, disabled, and/or elderly members of my family or household' },
                  { key: 'takingCareOfYounger', label: 'Taking care of younger family or household members' },
                  { key: 'takingCareOfOwnChild', label: 'Taking care of my own child or children' },
                  { key: 'workingPaidJob', label: "Working at a paid job to contribute to my household's income" },
                  { key: 'other', label: 'Other' },
                  { key: 'none', label: 'None of these' },
                ];
                return fields.map(({ key, label }) => {
                  const value = data.responsibilities?.[key];
                  const isChecked = value === true || value === 'Yes' || value === 'yes';
                  return (
                    <div className="gm-summary-checkbox-container" style={{ marginBottom: 16 }} key={key}>
                      <div className="gm-summary-text-primary">
                        <span
                          style={{
                            marginRight: '12px',
                            fontSize: '18px',
                            color: isChecked ? '#1890ff' : '#d9d9d9',
                            fontWeight: isChecked ? 'bold' : 'normal',
                          }}
                        >
                          {isChecked ? '✓' : '○'}
                        </span>
                        {label}
                      </div>
                      <div style={{ marginTop: 8 }}>
                        <div className="gm-summary-text-dark">{value !== undefined && value !== null && value !== '' ? value : '-'}</div>
                      </div>
                    </div>
                  );
                });
              })()}
              {data.responsibilities?.other && data.otherDescription && (
                <div className="gm-summary-conditional-section" style={{ marginBottom: 16 }}>
                  <div className="gm-summary-conditional-title">Other Description</div>
                  <div className="gm-summary-text-dark">{data.otherDescription}</div>
                </div>
              )}
            </div>
          </div>

          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Circumstances</div>
            <div>
              {(() => {
                const fields = [
                  { key: 'longCommute', label: 'Commuting 60 minutes or more to and from school each day' },
                  { key: 'homelessness', label: 'Experiencing homelessness or another unstable living situation' },
                  { key: 'unstableLiving', label: 'Living without consistent heat, power, water, or access to food' },
                  { key: 'unstableInternet', label: 'Living without reliable or usable internet' },
                  { key: 'livingIndependently', label: 'Living independently or living on my own (not including boarding school)' },
                  { key: 'none', label: 'None of these' },
                ];
                return fields.map(({ key, label }) => {
                  const value = data.circumstances?.[key];
                  const isChecked = value === true || value === 'Yes' || value === 'yes';
                  return (
                    <div className="gm-summary-checkbox-container" style={{ marginBottom: 16 }} key={key}>
                      <div className="gm-summary-text-primary">
                        <span
                          style={{
                            marginRight: '12px',
                            fontSize: '18px',
                            color: isChecked ? '#1890ff' : '#d9d9d9',
                            fontWeight: isChecked ? 'bold' : 'normal',
                          }}
                        >
                          {isChecked ? '✓' : '○'}
                        </span>
                        {label}
                      </div>
                      <div style={{ marginTop: 8 }}>
                        <div className="gm-summary-text-dark">{value !== undefined && value !== null && value !== '' ? value : '-'}</div>
                      </div>
                    </div>
                  );
                });
              })()}
            </div>
          </div>
        </>
      )}
      {/* {localStorage.getItem('userRole') === USER_ROLE.student && (
        <ModalCheckActivitiesFields
          show={show}
          onClose={handleClose}
          data={data}
          page="responsibilitiesAndCircumstances"
        />
      )} */}

      {getUserRole() === USER_ROLE.counselor && (
        <div className="gm-summary-checkbox-container">
          <div className="d-flex align-items-center" style={{ gap: '6px' }}>
            <input type="checkbox" style={{ width: '16px', height: '16px', border: '2px solid #6c757d', borderRadius: '2px' }} checked={reviewedAndComplete} onClick={onReviewdAndComplete} />
            <span style={{ fontSize: isMobile ? '14px' : '12px', color: '#6c757d', fontWeight: '500' }}>Reviewed & Complete!</span>
          </div>
        </div>
      )}
    </div>
  );
};
